// extracted by mini-css-extract-plugin
export default {"container":"DriverProfile_container__eBJwT","infoGrid":"DriverProfile_infoGrid__cDMOB","version":"DriverProfile_version__JmNr3"};